import React from 'react';
import PageHeader from '../../components/PageHeader';
import FaqList from '../../components/FaqList';
import { faqData } from './faqData';

const Faq = () => {
    const breadcrumbItems = [
        { label: 'Home', link: '/' },
        { label: 'Frequently Asked Questions.', link: '/faq' }
    ];

    return (
        <div>
            <PageHeader items={breadcrumbItems} pageTitle="Frequently Asked Questions." />
            <FaqList data={faqData} />
        </div>
    );
};

export default Faq;
